var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_378_13944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 6.55845C28.08 6.57204 27.1667 6.71007 26.2882 6.96836C26.6946 7.64332 26.911 8.40541 26.9167 9.18184C26.9167 9.78472 26.7909 10.3817 26.5466 10.9387C26.3023 11.4957 25.9443 12.0018 25.4929 12.4281C25.0415 12.8544 24.5056 13.1926 23.9158 13.4233C23.326 13.654 22.6939 13.7728 22.0555 13.7728C21.2334 13.7674 20.4265 13.563 19.7118 13.1792C19.1479 15.0261 19.2136 16.9937 19.8996 18.8033C20.5856 20.6129 21.8571 22.1728 23.534 23.2621C25.2109 24.3513 27.2081 24.9147 29.2429 24.8723C31.2776 24.83 33.2466 24.1841 34.8711 23.0262C36.4955 21.8682 37.693 20.257 38.294 18.4206C38.8949 16.5842 38.8688 14.6157 38.2194 12.7941C37.5699 10.9725 36.3301 9.39006 34.6754 8.27091C33.0208 7.15176 31.0352 6.55265 29 6.55845ZM53.698 14.5434C48.9905 5.869 39.671 0 29 0C18.329 0 9.00691 5.8731 4.30204 14.5442C4.10346 14.9152 4 15.325 4 15.7407C4 16.1564 4.10346 16.5662 4.30204 16.9372C9.00951 25.6116 18.329 31.4806 29 31.4806C39.671 31.4806 48.9931 25.6075 53.698 16.9364C53.8965 16.5654 54 16.1556 54 15.7399C54 15.3242 53.8965 14.9143 53.698 14.5434ZM29 27.5455C20.4366 27.5455 12.5859 23.0366 8.34632 15.7403C12.5859 8.44401 20.4357 3.93507 29 3.93507C37.5643 3.93507 45.4141 8.44401 49.6537 15.7403C45.415 23.0366 37.5643 27.5455 29 27.5455Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_378_13944",
    x: 0,
    y: 0,
    width: 58,
    height: 39.4806,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_378_13944"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_378_13944",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.6d0beec0e08a2c1f4c5972cf0e048494.svg";
export { ForwardRef as ReactComponent };